export default __webpack_public_path__ + "static/media/top-b-3-med.92145596.jpg";